import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { UitkLink } from 'uitk-react-link';
var UitkLinkTracked = ClickTracker(UitkLink);
export var FooterLinkSection = function (_a) {
    var _b;
    var section = _a.section;
    if (!((_b = section === null || section === void 0 ? void 0 : section.sectionData) === null || _b === void 0 ? void 0 : _b.length)) {
        return null;
    }
    return (React.createElement("ul", { className: "footer-link-list no-bullet" }, section.sectionData.map(function (item) {
        if (item && item.url && item.text && (item.type === 'link' || item.type === 'links')) {
            return (React.createElement("li", { key: item.id },
                React.createElement(UitkLinkTracked, { theme: "theme-link", linkName: "footer link item", rfrr: "Footer.CorporateLink", size: "small" },
                    React.createElement("a", { target: item.newWindow ? '_blank' : '_self', href: item.url },
                        ' ',
                        item.text,
                        item.newWindow ? React.createElement("span", { className: "screen-reader-only-hidden" }, item.newWindowAccessibilityText == null ? 'Opens in a new window' : item.newWindowAccessibilityText) : ''))));
        }
        return null;
    })));
};
//# sourceMappingURL=footer-link-section.js.map